import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { loggedInUser } from "../../services/auth.handlers";

const initialState = {
  loading: false,
  status: null,
  authToken: null,
  error: null,
};
export const loggedIn = createAsyncThunk("Auth/Login", async (data) => {
  const res = await loggedInUser(data);
  return res.data;
});

const AuthSlice = createSlice({
  name: "Auth",
  initialState,
  reducers: {
    loggedOut(state) {
      state.loading = false;
      state.authToken = null;
      state.status = null;
    },
  },
  extraReducers: {
    [loggedIn.pending]: (state) => {
      state.loading = false;
    },
    [loggedIn.fulfilled]: (state, { payload }) => {
      state.loading = true;
      state.status = payload.data.status === 200 ? true : false;
      if (payload.data.status === 200) {
        state.authToken = payload.data.authToken;
        state.error = null;
      } else {
        state.error = "Invalid Credentials";
      }
    },
    [loggedIn.rejected]: (state) => {
      state.loading = false;
    },
  },
});
export const { loggedOut } = AuthSlice.actions;

export default AuthSlice.reducer;
